<template>
<transition name="slide">
  <div class="datePicker" v-if="isShow">
    <div class="operation">
      <a class="prevMonth" href="javascript:;" @click="prevMonth" :class="{disabled: tempMonth + 1 <= startMonth && tempYear <= startYear}"></a>
      <div class="title">
        {{tempYear+'年'+getMonth+'月'}}
      </div>
      <a class="nextMonth" href="javascript:;" @click="nextMonth" :class="{disabled: tempMonth + 1 === endMonth && tempYear >= endYear}"></a>
    </div>
    <table cellpadding="0" cellspacing="0">
      <thead>
      <tr>
        <th v-for="item in weeks">
          {{item}}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="week in calcWeeks">
        <td v-for="date in 7">
          <a @click="changeSelect(calcDate(week, date))" :class="{selected: selectDate === calcDate(week, date) && selectYear === tempYear && selectMonth === tempMonth, prev: calcDate(week, date) < startDate && tempYear === startYear && tempMonth + 1 === startMonth, next: endYear === tempYear && endMonth === (tempMonth + 1) && calcDate(week, date) > endDate, not: calcDate(week, date) === ''}" href="javascript:;">{{calcDate(week, date)}}</a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</transition>
</template>

<script>
  const BIGMONTH = [1, 3, 5, 7, 8, 10, 12]
  const SMALLMONTH = [4, 6, 9, 11]
  export default {
    name: 'datePicker',
    props: {
      isShow: {
        type: Boolean,
        required: true,
        default: false
      },
      endYear: {
        type: Number,
        default: 4000
      },
      endMonth: {
        type: Number,
        default: 12
      },
      endDate: {
        type: Number,
        default: 31
      },
      isLimit: { // 今天以前的日期是否可以选择，默认可以
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        // months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
        // weeks: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        weeks: ['日', '一', '二', '三', '四', '五', '六'],
        date: null,
        time: null,
        startYear: 1900,
        startMonth: 1,
        startDate: 1,
        selectMonth: null,
        selectYear: null,
        selectDay: null,
        selectDate: null,
        firstDay: 1,
        lastDay: 31,
        tempMonth: null,
        tempYear: null
      }
    },
    created () {
      this._init()
    },
    computed: {
      /**
       * 计算有多少周
       * @return {[type]} [description]
       */
      calcWeeks () {
        return Math.ceil((this.firstDay + this.lastDay) / 7)
      },
      getMonth () {
        return (this.tempMonth + 1) > 9 ? (this.tempMonth + 1) : '0' + (this.tempMonth + 1)
      }
    },
    methods: {
      /**
       * 初始化时间
       * @return {[type]} [description]
       */
      _init () {
        // 设置初始值为当前日期
        this.date = new Date()
        // 初始化选中的日期
        this._calcSelectTime()
        // 如果限制了说明今天之前的日期不能选
        if (this.isLimit) {
          this.startYear = this.date.getFullYear()
          this.startMonth = this.date.getMonth() + 1
          this.startDate = this.date.getDate()
        }
        // 当前年份
        this.selectYear = this.date.getFullYear()
        // 当前月份
        this.selectMonth = this.date.getMonth()
        // 当前月份的某一天
        this.selectDate = this.date.getDate()
        // 一周中的第几天
        // this.nowDay = this.date.getDay()

        // 1号是当月第几天
        // this.firstDay = new Date(this.nowYear, this.nowMonth, 1).getDay()
        // this.lastDay = this._calcDays()
      },
      _calcSelectTime () {
        // 当前年份
        this.tempYear = this.date.getFullYear()
        // 当前月份
        this.tempMonth = this.date.getMonth()
        // 当前月份的某一天
//      this.selectDate = this.date.getDate()
        // 一周中的第几天
//      this.nowDay = this.date.getDay()

        // 1号是当月第几天
        this.firstDay = new Date(this.tempYear, this.tempMonth, 1).getDay()
        this.lastDay = this._calcDays()
      },
      /**
       * 计算当前选中的月份的天数
       * @return {[Number]} [当前月份的天数]
       */
      _calcDays () {
        let month = this.tempMonth + 1
        if (BIGMONTH.some((val) => val === month)) {
          return 31
        } else if (SMALLMONTH.some((val) => val === month)) {
          return 30
        } else if (this._isLeapYear(this.tempYear)) {
          return 29
        } else {
          return 28
        }
      },
      changeSelect (date) {
        if (date === '' || (this.tempYear === this.startYear && this.tempMonth + 1 === this.startMonth && date < this.startDate) || (this.tempYear === this.endYear && this.tempMonth + 1 === this.endMonth && date > this.endDate)) {
          return
        }
        this.selectYear = this.tempYear
        this.selectMonth = this.tempMonth
        this.selectDate = date
        let month = (this.selectMonth + 1) > 9 ? (this.selectMonth + 1) : '0' + (this.selectMonth + 1)
        let last = this.selectDate > 9 ? this.selectDate : '0' + this.selectDate
        this.$emit('select-date', this.selectYear, month, last)
      },
      /**
       * 根据星期和星期的第几天计算当天为多少号
       * @param  {[type]} week [description]
       * @param  {[type]} date [description]
       * @return {[type]}      [description]
       */
      calcDate (week, date) {
        let calcDate = date + (week - 1) * 7 - this.firstDay
        return (calcDate <= 0 || calcDate > this.lastDay) ? '' : calcDate
      },
      prevMonth () {
        if (this.tempMonth + 1 === this.startMonth && this.tempYear === this.startYear) {
          return
        }
        this.date = new Date(this.tempYear, this.tempMonth - 1, 1)
        this._calcSelectTime()
      },
      nextMonth () {
        if (this.tempYear === this.endYear && this.tempMonth + 1 === this.endMonth) {
          return
        }
//      this.selectIndex = null
        this.date = new Date(this.tempYear, this.tempMonth + 1, 1)
        this._calcSelectTime()
      },
      _isLeapYear (year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0
      }
    }
  }
</script>
<style scoped type="text/css" lang="stylus">
  @import '../../common/css/mixmin'
.datePicker
  width px2rem(484px)
  padding 0 px2rem(22px)
  position absolute
  left 50%
  top 100%
  transform translate3d(-50%, 0, 0)
  -webkit-transform translate3d(-50%, 0, 0)
  z-index 100
  font-size px2rem(24px)
  text-align center
  box-shadow 0 0 px2rem(10px) #ccc
  opacity 1
  background-color #fff
  &.slide-enter-active, &.slide-leave-active
    transition opacity .3s
  &.slide-enter, &.slide-leave-active
    opacity 0
.operation
  box-sizing: border-box
  border-left: 1px solid rgba(255, 255, 255, 1)
  border-right: 1px solid rgba(255, 255, 255, 1)
  width: 100%
  height: px2rem(60px)
  background-color: #fff
  color: #333
  a
    width px2rem(60px)
    float left
    height px2rem(60px)
    line-height px2rem(60px)
    text-decoration: none
    position relative
    &.disabled
      cursor not-allowed
    &::after
      content ''
      display block
      position absolute
      left 50%
      top 50%
      width px2rem(16px)
      height px2rem(16px)
      transform-origin center center
      -webkit-transform-origin center center
      -ms-transform-origin center center
    &:nth-of-type(1)::after
      border-left: 1px solid #999;
      border-bottom: 1px solid #999;
      transform: translate(-50%, -50%) rotate(45deg);
      -webkit-transform: translate(-50%, -50%) rotate(45deg);
      -ms-transform: translate(-50%, -50%) rotate(45deg);
    &:nth-of-type(2)
      float right
    &:nth-of-type(2)::after
      border-right: 1px solid #999;
      border-bottom: 1px solid #999;
      transform: translate(-50%, -50%) rotate(-45deg);
      -webkit-transform: translate(-50%, -50%) rotate(-45deg);
      -ms-transform: translate(-50%, -50%) rotate(-45deg);
    &:hover::before,
    &:hover::after
      border-color rgba(78,209,255,1)
    &.disabled:hover::before,
    &.disabled:hover::after
      border-color #999
  .title
    float left
    width px2rem(316px)
    height px2rem(60px)
    line-height px2rem(60px)
    color #333
table
  border-collapse collapse
  tr, td
    width px2rem(60px)
    height px2rem(60px)
  tr
    color #333
  th, td
    font-weight normal
    text-align center
    border 1px solid rgba(255, 255, 255, 1)
  td
    background-color rgba(255, 255, 255, 1)
    a
      display block
      width px2rem(60px)
      height px2rem(60px)
      line-height px2rem(60px)
      text-decoration none
      color rgba(255, 255, 255, 1)
      border-radius 50%
      background-color #fff
      color #6b7d8e

      &:hover,
      &.active,
      &.selected {
        color #fff
        background-color rgba(78,209,255,1)
      }
      &.prev
        color #ddd
        cursor not-allowed
        background-color #fff
      &.prev:hover
        background-color #fff
      &.not, &.next
        cursor not-allowed
        color #6b7d8e
        background-color #fff
      &.not:hover
        background-color #eee
      &.next
        color #ddd
        background-color #fff
      &.next:hover
        background-color: #fff;
</style>




// WEBPACK FOOTER //
// date.vue?2203eb7a